$(document).ready(function(){

	// -- mainMenuTrigger --
	$('.mainMenuTrigger .hamburger').on('click', function(){
		$('body').toggleClass('mainMenuMobile--open');
		$(this).toggleClass('is-active');
	});

	// -- Close mobile menu when click
	$('.main__nav li a:not(.dropdown-toggle), .langMenu .dropdown-toggle').on('click touchend', function(){
		$('body').removeClass('mainMenuMobile--open');
		$('.mainMenuTrigger .hamburger').removeClass('is-active');
	});

	// -- Dropdown --
	$(document).on('click', '.dropdown-toggle', function(e){
		if ($(this).hasClass('type--sectionMenu')) {
			e.preventDefault();
		}
	});
	$(document).on('mouseover', '.dropdown', function(){
		$(this).addClass('open');
	});
	$(document).on('mouseleave', '.dropdown', function(){
		$(this).removeClass('open');
	});

	// -- Dropdown --
	// $(document).on('click touchend', '.dropdown-toggle', function(e){
	// 	e.preventDefault();
	// 	if (!$(this).parent('.dropdown').hasClass('open')) {
	// 		if (!$(this).parents('.dropdown-menu').hasClass('level--2')) {
	// 			$('.dropdown').removeClass('open');
	// 		}
	// 	}
	// 	$(this).parent('.dropdown').toggleClass('open');
	// });
	// setDropdownPosition();

	// -- Close dropdown when click outside --
	// $(document).on('mouseup', function(e) {
	//   var container = $('.dropdown');
	//   if (!container.is(e.target) && container.has(e.target).length === 0) {
	// 		$('.dropdown').removeClass('open');
	//   }
	// });



});


// $(window).resize(function() {
// 	setDropdownPosition();
// });


// function setDropdownPosition(){
// 	$('.mainMenu .dropdown-menu, .subMenu .dropdown-menu').each(function(index, value){
 
//     var elm = $(value);
//     var off = elm.offset();
//     var l = off.left;
//     var w = elm.width();
//     var docH = $('.body__inner').height();
//     var docW = $('.body__inner').width();

//     var isEntirelyVisible = (l + w <= docW);

//     if (!isEntirelyVisible) {
//       $(this).addClass('edge');
//     }

// 	});
// }